module.exports = __webpack_public_path__ + "img/dots-icon.25e6e440.svg";